import React, { useState, useEffect } from "react";
import Input from "../../input";
import { useForm } from "react-hook-form";
import { Modal } from "antd";
import Button from "../../button";
import Icon from "../../../assets/icons";
import { Plus } from "lucide-react";
import { RingLoader } from "react-spinners";
import useApi from "../../hooks/request";
import { showToast } from "../../toast";
import StepIndicator from "./steps";
import Eligibility from "./eligibility-page";
import DiscountInfo from "./discount-information";



interface AddDiscountDialogProps {
    isVisible: boolean;
    onClose: () => void;
    discount?: any;
}

type FormStep = "discountInfo" | "eligibility"  ;
const AddDiscountDialog: React.FC<AddDiscountDialogProps>= ({
    isVisible,
    onClose,
    discount,
}) => {

    const [currentStep, setCurrentStep] = useState<FormStep>("discountInfo");
    
    

    const {
        control,
        setValue,
        handleSubmit,
        trigger,
        clearErrors,
        formState: { errors },
    } = useForm({
        mode: "onChange",
    });

    const {loading, makeRequest} = useApi(`/discounts/${discount?._id}`, "PUT");

    const handleCreateDiscount = handleSubmit(async (formData) => {

        const discount = {
            
                "name": formData.name,
                "discountType": formData.discountType,
                "discountValue": formData.discountValue,
                "startDate": formData.startDate,
                "endDate": formData.endDate,
                "discountCode": formData.discountCode,
                "description": formData.description,
                "eligibleItems": formData.eligibleItems,
                "eligibleCustomers": formData.eligibleCustomers,
                "minimumPurchaseRequirement": formData.minimumPurchaseRequirement,
                "usageLimit": formData.usageLimit,
                "termsAndConditions": formData.termsAndConditions,
            
        }


        const [response] = await makeRequest(discount);
         if (response.status) {
            showToast(response.message, true, { position: "top-right" });
            onClose();
            window.location.reload();
        } else {
            showToast(response?.message, false, { position: "top-right" });
        }
    })

    const validateAndProceed = async () => {
        let isValid = true;

        if (currentStep === "discountInfo") {
            const fieldsToValidate = [
                "name",
                "discountType",
                "startDate",
                "endDate",
                "discountCode",
                "description",
                "discountCode",
            ];
            isValid = await trigger(fieldsToValidate)
        } else if (currentStep === "eligibility") {
            const fieldsToValidate = [
                "eligibleItems",
                "eligibleCustomers",
                "minimumPurchaseRequirement",
                "usageLimit",
            ];
            isValid = await trigger(fieldsToValidate)
        }

        if (isValid) {
            if (currentStep === "discountInfo") {
                setCurrentStep("eligibility")
            } else if (currentStep === "eligibility") {
                handleCreateDiscount()
            }
        }
    };

    const goBackToPreviousStep = () => {
        if(currentStep === "eligibility")
            setCurrentStep("discountInfo")
    }


    const renderStepContent = () => {
        switch (currentStep) {
            case "discountInfo" :
                return (
                    <DiscountInfo
                        control={control}
                        clearErrors={clearErrors}
                        errors={errors}
                        discount={discount}
                    />
                );
            case "eligibility":
                return (
                    <Eligibility
                        control={control}
                        clearErrors={clearErrors}
                        errors={errors}
                        discount={discount}
                    />
                )
        }
    }


    const renderFooterButtons = () => {
        if(currentStep === "discountInfo") {
            return (
                <div className="flex gap-3 py-2 mt-4">
                    <Button
                        type="button"
                        className="hover:bg-green-700 flex items-center"
                        onClick={validateAndProceed}
                        variant="primary"
                        size="lg"
                    >
                        <Icon name="noteIcon" />
                        Proceed to Eligibility & Conditions
                    </Button>
                </div>
            )
        } else if (currentStep === "eligibility") {
            return (
                <div className="flex justify-between gap-2 py-2 mt-4">
                  <button
                    type="button"
                    className="bg-[#E8F2E8] w-full rounded-full hover:bg-gray-200 pl-20 py-2 text-[#047401] flex font-medium"
                    onClick={goBackToPreviousStep}
                  >
                    <Icon name="backIcon" />
                    Back to KYC
                  </button>
                  <Button
                    type="button"
                    variant="primary"
                    size="lg"
                    className="hover:bg-green-700 text-white flex items-center"
                    onClick={validateAndProceed}
                  >
                    {loading ? (
                      <RingLoader color="#ffffff" loading={loading} size={20} />
                    ) : (
                      <div className="flex gap-3">
                        Submit for Approval <Icon name="noteIcon" />
                      </div>
                    )}
                  </Button>
                </div>
              );
        }
        return null;
    };




    return (
        <Modal
          visible={isVisible}
          onCancel={onClose}
          width={560}
          footer={null}
          style={{
            position: "absolute",
            top: "10px",
            right: "20px",
            margin: 0,
            paddingBottom: 0,
          }}
        >
          <h1 className="text-2xl font-bold -mt-2 mb-4">Edit Promotion</h1>
          <StepIndicator
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
          <form onSubmit={handleCreateDiscount}>
            <div className="grid gap-4">{renderStepContent()}</div>
            {renderFooterButtons()}
          </form>
        </Modal>
    );
}
 
export default AddDiscountDialog;